import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const UserHeader = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [settingsTab, setSettingsTab] = useState('profile');
  const [profile, setProfile] = useState({ name: '', email: '', phone: '' });
  const [notifications, setNotifications] = useState({
    maintenance: true,
    sms: true,
    reports: false,
    rent: true
  });
  const [security, setSecurity] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

  useEffect(() => {
    getUser();
  }, []);

  const handleSave = async () => {
    // Save logic here
    setShowSettingsModal(false);
  };

  const getUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setUser(user);
    if (user) {
      checkAdminStatus(user.id);
    }
  };

  const checkAdminStatus = async (userId) => {
    try {
      const { data } = await supabase
        .from('accounts')
        .select('role')
        .eq('user_id', userId)
        .single();
      setIsAdmin(data?.role === 'admin');
    } catch (error) {
      setIsAdmin(false);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  const getInitials = (email) => {
    return email ? email.substring(0, 2).toUpperCase() : 'U';
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: '250px',
      right: 0,
      height: '60px',
      background: 'white',
      borderBottom: '1px solid #ddd',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px',
      zIndex: 999
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <h3 style={{ margin: 0, color: '#2c3e50' }}>Rental Property Management</h3>
        {isAdmin && window.location.pathname === '/resident-dashboard' && (
          <button 
            onClick={() => window.location.href = '/owner-dashboard'}
            style={{
              padding: '6px 12px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer'
            }}
          >
            Admin Dashboard
          </button>
        )}
        {isAdmin && window.location.pathname === '/owner-dashboard' && (
          <button 
            onClick={() => window.location.href = '/resident-dashboard'}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '12px',
              cursor: 'pointer'
            }}
          >
            Resident View
          </button>
        )}
      </div>
      
      <div style={{ position: 'relative' }}>
        <div 
          onClick={() => setShowDropdown(!showDropdown)}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            padding: '8px 12px',
            borderRadius: '6px',
            background: showDropdown ? '#f8f9fa' : 'transparent'
          }}
        >
          <div style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            background: '#007bff',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            marginRight: '8px'
          }}>
            {getInitials(user?.email)}
          </div>
          <span style={{ fontSize: '14px', color: '#333' }}>{user?.email}</span>
          <span style={{ marginLeft: '8px', fontSize: '12px' }}>▼</span>
        </div>

        {showDropdown && (
          <div style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: '6px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            minWidth: '200px',
            marginTop: '4px'
          }}>
            <div style={{ padding: '8px 0' }}>
              <button
                onClick={() => { setSettingsTab('profile'); setShowSettingsModal(true); setShowDropdown(false); }}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  border: 'none',
                  background: 'transparent',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
                onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
                onMouseOut={(e) => e.target.style.background = 'transparent'}
              >
                Profile Settings
              </button>
              <button
                onClick={() => { setSettingsTab('notifications'); setShowSettingsModal(true); setShowDropdown(false); }}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  border: 'none',
                  background: 'transparent',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
                onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
                onMouseOut={(e) => e.target.style.background = 'transparent'}
              >
                Notifications
              </button>
              <button
                onClick={() => { setSettingsTab('security'); setShowSettingsModal(true); setShowDropdown(false); }}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  border: 'none',
                  background: 'transparent',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
                onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
                onMouseOut={(e) => e.target.style.background = 'transparent'}
              >
                Security
              </button>
              <button
                onClick={handleLogout}
                style={{
                  width: '100%',
                  padding: '8px 16px',
                  border: 'none',
                  background: 'transparent',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
                onMouseOver={(e) => e.target.style.background = '#f8f9fa'}
                onMouseOut={(e) => e.target.style.background = 'transparent'}
              >
                Logout
              </button>
            </div>
          </div>
        )}

        {/* Settings Modal */}
        {showSettingsModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1001
          }}>
            <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', width: '500px', maxHeight: '80vh', overflow: 'auto' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3 style={{ margin: 0 }}>Settings</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => setSettingsTab('profile')}
                    style={{
                      padding: '4px 12px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      backgroundColor: settingsTab === 'profile' ? '#007bff' : 'white',
                      color: settingsTab === 'profile' ? 'white' : '#333',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    Profile
                  </button>
                  <button
                    onClick={() => setSettingsTab('notifications')}
                    style={{
                      padding: '4px 12px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      backgroundColor: settingsTab === 'notifications' ? '#007bff' : 'white',
                      color: settingsTab === 'notifications' ? 'white' : '#333',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    Notifications
                  </button>
                  <button
                    onClick={() => setSettingsTab('security')}
                    style={{
                      padding: '4px 12px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      backgroundColor: settingsTab === 'security' ? '#007bff' : 'white',
                      color: settingsTab === 'security' ? 'white' : '#333',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}
                  >
                    Security
                  </button>
                </div>
              </div>
              
              {settingsTab === 'profile' && (
                <div style={{ display: 'grid', gap: '16px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Full Name</label>
                    <input
                      type="text"
                      value={profile.name}
                      onChange={(e) => setProfile({...profile, name: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Email</label>
                    <input
                      type="email"
                      value={profile.email}
                      onChange={(e) => setProfile({...profile, email: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Enter your email"
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Phone</label>
                    <input
                      type="tel"
                      value={profile.phone}
                      onChange={(e) => setProfile({...profile, phone: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Enter your phone number"
                    />
                  </div>
                </div>
              )}
              
              {settingsTab === 'notifications' && (
                <div style={{ display: 'grid', gap: '12px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      checked={notifications.maintenance}
                      onChange={(e) => setNotifications({...notifications, maintenance: e.target.checked})}
                    />
                    Email notifications for maintenance requests
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      checked={notifications.sms}
                      onChange={(e) => setNotifications({...notifications, sms: e.target.checked})}
                    />
                    SMS notifications for urgent issues
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      checked={notifications.reports}
                      onChange={(e) => setNotifications({...notifications, reports: e.target.checked})}
                    />
                    Weekly property reports
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      checked={notifications.rent}
                      onChange={(e) => setNotifications({...notifications, rent: e.target.checked})}
                    />
                    Rent payment reminders
                  </label>
                </div>
              )}
              
              {settingsTab === 'security' && (
                <div style={{ display: 'grid', gap: '16px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Current Password</label>
                    <input
                      type="password"
                      value={security.currentPassword}
                      onChange={(e) => setSecurity({...security, currentPassword: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Enter current password"
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>New Password</label>
                    <input
                      type="password"
                      value={security.newPassword}
                      onChange={(e) => setSecurity({...security, newPassword: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Enter new password"
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px' }}>Confirm New Password</label>
                    <input
                      type="password"
                      value={security.confirmPassword}
                      onChange={(e) => setSecurity({...security, confirmPassword: e.target.value})}
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                      placeholder="Confirm new password"
                    />
                  </div>
                  <div style={{ padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <h4 style={{ margin: '0 0 8px 0', fontSize: '14px' }}>Two-Factor Authentication</h4>
                    <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>Add extra security to your account</p>
                    <button style={{
                      padding: '6px 12px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      backgroundColor: 'white',
                      cursor: 'pointer',
                      fontSize: '12px'
                    }}>
                      Enable 2FA
                    </button>
                  </div>
                </div>
              )}
              
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '20px' }}>
                <button
                  onClick={() => setShowSettingsModal(false)}
                  style={{
                    padding: '8px 16px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserHeader;